var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 4V13.8333C2.99992 14.7668 2.99992 15.2331 3.18157 15.5897C3.34136 15.9033 3.59615 16.1587 3.90975 16.3185C4.26592 16.5 4.73241 16.5 5.66401 16.5H10.3358C11.2674 16.5 11.7332 16.5 12.0894 16.3185C12.403 16.1587 12.6587 15.9033 12.8184 15.5897C12.9999 15.2335 12.9999 14.7675 12.9999 13.8359V4M2.99992 4H4.66659M2.99992 4H1.33325M4.66659 4H11.3333M4.66659 4C4.66659 3.22343 4.66659 2.83534 4.79345 2.52905C4.96261 2.12067 5.28685 1.79602 5.69523 1.62687C6.00152 1.5 6.39002 1.5 7.16659 1.5H8.83325C9.60982 1.5 9.99811 1.5 10.3044 1.62687C10.7128 1.79602 11.0371 2.12067 11.2063 2.52905C11.3332 2.83534 11.3333 3.22343 11.3333 4M11.3333 4H12.9999M12.9999 4H14.6666",
    stroke: "#EE5050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.afd1bf4e4d8761983716fd1088e67531.svg";
export { ForwardRef as ReactComponent };